
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/stores",
      function () {
        return require("private-next-pages/stores.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/stores"])
      });
    }
  